import { postConciliacionBancariaManual } from "api/ConciliacionBancaria.service"
import { MovimientoBancarioReadingDtoProps } from "api/DTOs/MovimientoBancarioReadingDto"
import { addNotaMovimientoBancario } from "api/MovimientoBancario.service"
import { MovimientoBancarioReadingDtoIPagedEnumerableProps } from "api/Schemas/MovimientoBancarioReadingDtoIPagedEnumerable"
import notification from "common/utils/notification"
import { TFunction } from "i18next"
import { useState } from "react"
import useModalAndCreate from "../../../hooks/useModalAndCreate"
import { SelectedDocumentsProps } from "../layout/ColumnRight"

export type TablaConciliarMovimientosDataProps =
  MovimientoBancarioReadingDtoProps & { importePendiente?: number }
export interface HandleConfirmManualConciliacionProps {
  selectedDocuments: Array<SelectedDocumentsProps>
  idExterno?: MovimientoBancarioReadingDtoProps
}

export const useManualRowSelection = ({
  t,
  fetchTableData,
  paramId,
}: {
  t: TFunction
  fetchTableData: () => Promise<MovimientoBancarioReadingDtoIPagedEnumerableProps>
  paramId: string
}) => {
  const [isUpperSectionExpanded, setIsUpperSectionExpanded] = useState(false)
  const [isUpperSectionExpandedSecond, setIsUpperSectionExpandedSecond] =
    useState(false)
  const [showModalAsiento, setShowModalAsiento] = useState(false)
  const [selectedNewLeft, setSelectedNewLeft] = useState<
    MovimientoBancarioReadingDtoProps[]
  >([])

  const [selectedNewRight, setSelectedNewRight] = useState<
    SelectedDocumentsProps[]
  >([])

  const [showModalRestaurarConciliacion, setShowModalRestaurarConciliacion] =
    useState<boolean>(false)
  const [showModalMarcarConciliado, setShowModalMarcarConciliado] =
    useState<boolean>(false)
  const [showDesconciliarModalData, setShowDesconciliarModalData] =
    useState<boolean>(false)

  const {
    handleOpenCreateModal: handleCreateNotaModal,
    showCreateModal: showCreateNotaModal,
    handleCloseCreateModal,
  } = useModalAndCreate()

  const toggleUpperSection = () => {
    setIsUpperSectionExpanded(!isUpperSectionExpanded)
  }

  const toggleUpperSectionSecond = () => {
    setIsUpperSectionExpandedSecond(!isUpperSectionExpandedSecond)
  }

  const handleUnselectRows = () => {
    setSelectedNewLeft([])
    setSelectedNewRight([])
  }

  const handleConfirmManualConciliacion = async ({
    selectedDocuments,
  }: HandleConfirmManualConciliacionProps) => {
    try {
      const agrupatedDocuments = selectedDocuments.reduce((acc, item) => {
        const { tabKey, id } = item
        if (!acc[tabKey]) {
          acc[tabKey] = []
        }
        id && acc[tabKey].push(id)
        return acc
      }, {} as Record<string, string[]>)
      const params = {
        ...agrupatedDocuments,
        ...(agrupatedDocuments?.facturaIds
          ? { facturaIds: agrupatedDocuments?.facturaIds }
          : {}),
        cuentaBancariaId: paramId as string,
        movimientoBancarioIdsExternos: selectedNewLeft.map(
          (item) => item.idExterno as string
        ),
      }

      await postConciliacionBancariaManual(params)
      handleUnselectRows()
      fetchTableData()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  const handleCreateNota = async (values: { descripcion: string }) => {
    try {
      await addNotaMovimientoBancario({
        idExterno: showCreateNotaModal?.data.idExterno,
        nota: values.descripcion,
      }).then(() => {
        handleCloseCreateModal()
        notification.success({
          body: `${t("bancos.msg.noteExit")}`,
        })
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      fetchTableData()
    }
  }

  const upperSectionForzada = () => {
    setIsUpperSectionExpanded(true)
    setIsUpperSectionExpandedSecond(true)
  }

  return {
    handleCloseCreateModal,
    handleConfirmManualConciliacion,
    handleCreateNota,
    handleCreateNotaModal,
    handleUnselectRows,
    isUpperSectionExpanded,
    isUpperSectionExpandedSecond,
    setShowDesconciliarModalData,
    setShowModalAsiento,
    setShowModalMarcarConciliado,
    setShowModalRestaurarConciliacion,
    showCreateNotaModal,
    showDesconciliarModalData,
    showModalAsiento,
    showModalMarcarConciliado,
    showModalRestaurarConciliacion,
    toggleUpperSection,
    toggleUpperSectionSecond,
    upperSectionForzada,
    selectedNewLeft,
    setSelectedNewLeft,
    selectedNewRight,
    setSelectedNewRight,
  }
}
